import React, { useEffect, useState } from "react";
import classes from "./Layout.module.css";
import Lottie from "lottie-react";
import thunderAnimation from "../animations/thunder-animation.json";
import snowfallAnimation from "../animations/snowfall-animation.json";
import ReactPlayer from "react-player";
import LargeLoader from "./Loaders/LargeLoader";
// import LoadingScreen from "./LoadingScreen";

const Layout = ({ children }) => {
    // const [loading, setLoading] = useState(true);

    // useEffect(() => {
    //     setTimeout(() => {
    //         setLoading(false);
    //     }, [30000]);
    // }, []);

    return (
        <div className={classes.game_overlay}>
            <div className={classes.game_container}>
                <div className={classes.animations}>
                    <Lottie
                        animationData={snowfallAnimation}
                        loop
                        autoPlay
                        className={classes.animation}
                    />
                </div>
                <div className={classes.cloud_container}>
                    {/* <ReactPlayer
                        url={`/assets/videos/cloud.mp4`}
                        muted
                        className={classes.video}
                        height="100%"
                        playing={true}
                        loop={true}
                        playsinline
                        // onReady={() => setLoading(false)}
                        config={{
                            file: {
                                attributes: {
                                    playsInline: true,
                                },
                            },
                        }}
                    /> */}
                </div>
                {/* {loading ? (
                    <LargeLoader />
                ) : ( */}
                    <div className={classes.game}>
                        {children}
                    </div>
                {/* )} */}
            </div>
        </div>
    )
};
export default Layout;